module.exports = "img/17.7937e2.webp";